import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import SyncIcon from '@material-ui/icons/Sync';
import IconButton from '@material-ui/core/IconButton';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Typography from 'Components/UI/Typography';
import MetaReadOnlyView from 'Components/UI/Meta/MetaReadOnlyView';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
  },
  header: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
  },
  headerText: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  headerRightSide: {
    display: 'flex',
    flexFlow: 'row',
  },
  refreshButton: {
    marginRight: theme.spacing(1),
  },
  subHeader: {
    fontWeight: theme.typography.fontWeightMedium,
  },
  suspendedStatus: {
    marginTop: theme.spacing(2),
    color: theme.palette.facet.orange,
  },
  row: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(2),
  },
  labelsAndValues: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(1),
  },
  labelsAndValuesRow: {
    display: 'flex',
    flexFlow: 'row',
    marginTop: theme.spacing(2),
  },
  labelsAndValuesL: {
    display: 'flex',
    flexFlow: 'column',
    marginLeft: theme.spacing(2),
  },
  labelsAndValuesR: {
    display: 'flex',
    flexFlow: 'column',
    marginLeft: theme.spacing(2),
  },
  prompt: {
    fontWeight: theme.typography.fontWeightBold,
  },
  value: {
    fontWeight: theme.typography.fontWeightMedium,
  },
});

const View = ({
  classes,
  resource,
  onClose,
  onClickRefresh,
  amplitudeRootNodeProps,
}) => {
  return (
    <Box className={classes.root} {...amplitudeRootNodeProps}>
      <div className={classes.header}>
        <Typography
          variant="h4"
          className={classes.headerText}
          color="primary"
        >
          ACH Relationship
        </Typography>
        <div className={classes.headerRightSide}>
          <IconButton
            className={classes.refreshButton}
            onClick={onClickRefresh}
            variant="contained"
            color="primary"
          >
            <SyncIcon />
          </IconButton>
          <IconButton
            color="primary"
            onClick={onClose}
          >
            <CancelIcon />
          </IconButton>
        </div>
      </div>
      <Typography
        variant="h6"
        className={classes.subHeader}
      >
        {resource.attr('accountNumber')}
      </Typography>
      <Typography
        variant="h6"
        className={classes.suspendedStatus}
      >
        {resource.selectedOptionPrompt('status') || ''}
      </Typography>
      <MetaReadOnlyView resource={resource} />
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onClickRefresh: PropTypes.func.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
};

export default withStyles(styles)(View);
